import Component from "../component.abstract"
import {getOffset, resizeMainContainer} from "../helpers/html-utils"
import {getSubTypePage} from "../analytics/utils"
import { getAllInstancesByName, getSingleInstanceByElement, initialiseComponents } from "../../core";
import DataCount from "../facets-nb/data-count";
import { hw } from "../helpers/paths"
import ValidatedForm from "../form/validated-form/validated-form";
import { SimpleSelectItem } from "../inputs/simple-select/simple-select";
import { numberWithSpace } from "../helpers/number";


interface SelectorProps {
    facet: string | boolean | undefined
    facetRAZ: string | undefined
    status: string | undefined
    supername: string | undefined
    superfacet: string | undefined
    sortable: string | undefined
    src: string | undefined
    type: string | undefined
    default: string | undefined
    pluriel: string | undefined
    limit: string | undefined
    forceDrop: string | boolean | undefined
    unselectall: boolean | undefined
    displayBelow: boolean | undefined
    forceBlur: boolean | undefined
    fakefacet: string | undefined
    labelAfter: string | undefined
    displaySingle: boolean | undefined
    pastActiv: boolean | undefined
    class?: string
}
interface EventCustom extends Event {
    x:number
    y:number
}

export default class Selector extends Component {
    readonly name: string;
    readonly multiple:boolean;
    private hasBeenOpened:boolean;
    private openInput:any;
    private placeholder = "";
    public options:any[] = [];
    private opened = false;
    private column = 1;
    private numberOnColumn = 0;
    private moduloOnColumn = 0;
    readonly facet: string | boolean | undefined = false;
    readonly fakeFacet: string | boolean = false;
    readonly facetRAZ: string | undefined;
    private sortable = false;
    private specialLaunch = false;
    private randomnumber =  + Math.floor(Math.random() * 10000);
    readonly supername: string | undefined; 
    private superfacet: string | undefined;
    private button: HTMLElement;
    private choices:any[] = [];
    private usedChoice = 0;
    private choiceWrapper: any;
    private choiceWrapperList: any;
    public groups:any[] = [];
    private default = "";
    private pluriel = "";
    private displayBelow = false;
    private belowUl:any;
    private src: string | undefined;
    private form: string | undefined;
    private eventHistory: Event[]
    private limit = 1;
    private launch = false;
    private selectors: any[] = [];
    private type: string | undefined;
    private unselector = false;
    private forceDrop: boolean | string = "forceDrop";
    private forceBlur: boolean | string = "forceBlur";
    private labelAfter= false;
    private initState:any[];
    private displaySingle= false;
    private hasUploader= false;
    private unselectAllLbl:any;
    private timeout:any;
    private checkWithUploader: ValidatedForm;
    private pastActiv = true;
    private workAsRay = false;
   
     constructor (
        private props: SelectorProps,
        element: HTMLElement
    ) {  
        super(props, element)
        this.name = this.element.getAttribute("name");
        this.multiple = this.element.hasAttribute("multiple")
        this.placeholder = this.element.getAttribute("placeholder");

        Array.from(this.element.children).forEach((child: HTMLElement) => {
            if (child.nodeName === "OPTION" && child.textContent !== this.placeholder) {
                this.options.push(child);
            } else if (this.multiple && child.nodeName == "OPTGROUP") {
                this.options.push(child);
            }
        });
 
        this.opened =  (this.props.status && this.props.status == "opened");
        if(this.props.facet){
            this.facet = this.props.facet
        } else {
             if (this.element.hasAttribute("data-facet-r")) {
               this.facet = this.element.hasAttribute("data-facet-r");
             }
        }
        if(this.props.facetRAZ) {
            this.facetRAZ = this.props.facetRAZ
        }
        if (this.props.supername && this.props.superfacet) {
            this.supername = this.props.supername;
            this.superfacet = this.props.superfacet;
        }
        if(this.props.sortable) {
            this.sortable = (this.props.sortable.toString() === "true");
        }
        //needed for contract mobile name-enginec
        if(this.props.fakefacet) {
           this.fakeFacet = this.props.fakefacet
        }
        if(this.props.src) {
            this.src = this.props.src;
        }
        this.form = this.element.getAttribute("form");
        if(this.props.type) {
            this.type = this.props.type
        }
        if(this.props.default) {
            this.default = this.props.default
        }
        if(this.props.pluriel) {
            this.pluriel = this.props.pluriel
        }
        if(this.props.limit) {
            this.limit = parseInt(this.props.limit)
        }
        if(this.props.pastActiv !== undefined) {
            this.pastActiv = this.props.pastActiv;
        }
        if(this.placeholder === "") {
            if(this.multiple && this.options.length === 1) {
                 this.placeholder = this.options[0].innerText;
            } else {
                this.placeholder = "Sélectionner une option";
            }
        }
        if(this.multiple) {
            if(this.props.forceDrop) {
                if (this.props.forceDrop + "" == "true") {
                    this.forceDrop = "forceDrop";
                } else {
                    if (this.props.forceDrop + "" != "") {
                        this.forceDrop = this.props.forceDrop + "";
                    } else {
                        this.forceDrop = false;
                    }
                }
            } else {
                this.forceDrop = false;
            }
            if(this.props.unselectall && this.props.unselectall + "" === "true") {
                this.unselector = true;
            }
            if(this.props.displayBelow && this.props.displayBelow + "" === "true") {
                this.displayBelow = true;
            }
        }
        if(this.props.forceBlur && this.props.forceBlur+ "" !== "true" ) {
             if (this.props.forceBlur + "" != "") {
                this.forceBlur = this.props.forceBlur + "";
            } else {
                if (this.props.facet || this.fakeFacet) {
                    this.forceBlur = false;
                }
            }
        } else if(this.props.facet || this.fakeFacet) {
             this.forceBlur = false;
        }
        if(this.props.labelAfter) {
            this.labelAfter = true;
        }
        if(this.props.displaySingle) {
            this.displaySingle = true;
        }

        // Use "as-ray" class to make the component work like "ray"
        if (this.element.classList.contains("as-ray")) {
            this.workAsRay = true;
        }
    }

    mounted():void {
        if (this.forceDrop) {
            this.element.classList.add(this.forceDrop.toString())
        } else if (this.options.length < 7) {
                this.element.classList.add("checklist")
        }

         // Generate and append the needed elements
        const parentWrapper = document.createElement("div");
        const parentWrapper2 = document.createElement("div");
        // Add CSS classes from parameters
        if (this.props.class) {
            parentWrapper2.classList.add(...this.props.class.split(" "));
        }
        // Add Tailwind classes as well
        parentWrapper2.classList.add(...Array.from(this.element.classList).filter((cssClass: string) => {
            return cssClass.startsWith("tw-");
        }));
        parentWrapper.appendChild(parentWrapper2);
        const type = "data-select" + (this.type ? "-" + this.type : "");
        parentWrapper2.setAttribute(type, "");
        parentWrapper2.setAttribute('data-cypress-' + this.name, "");
        this.element.parentNode.insertBefore(parentWrapper2, this.element.nextSibling);
        parentWrapper2.appendChild(this.element);
        this.openInput = document.createElement("input");
        this.openInput.setAttribute("type", "checkbox");
        if (this.opened) {
            this.openInput.setAttribute("checked", "checked");
        }
        this.openInput.setAttribute("id", this.name + this.randomnumber + "_button");
        this.element.parentNode.insertBefore(this.openInput, this.element.nextSibling);

         if (this.displayBelow) {
            this.belowUl =  document.createElement("ul");
            this.element.parentNode.appendChild(this.belowUl);

            // Display already selected items
            this.options.filter((option: HTMLOptionElement) => {
                return option.selected;
            }).forEach((option: HTMLOptionElement) => {
                this.addTag(option);
            });
        }
        const wrapper = this.generate();

        this.element.parentNode.insertBefore(wrapper, this.openInput.nextSibling);
 
        PubSub.publish("selector-loaded."+this.name,this)

        // once the generated elements are appended to the DOM, a binding is launched to get the actual values of the select tag
        this.toggleBind(this.groups);
        this.element.addEventListener("change", ()=> {this.toggleBind(this.groups)});

        this.openInput.addEventListener("change", () => {
            if (this.openInput.checked) {
                PubSub.publish("selector.visibility.open", this);
            } else {
                PubSub.publish("selector.visibility.close", this);
            }
            if (window.innerWidth > 767) {
                // when we open or close facets we need to apply a min-height property on main container to avoid facets container from going over footer
                resizeMainContainer()
            }
        });

        if(this.src) {
            for (let i = 0; i < this.src.length; i++) {
                 if (this.src[i] == "accountData") {
                     PubSub.subscribe("account-data",()=>{
                          this.reloadOptions(undefined, true)
                     })  
                 }
                  if (this.src[i] == "uploader") {
                     if (this.element.getAttribute("id") == "Answer_FileId") {
                        this.hasUploader = true;
                        const uploader = getSingleInstanceByElement("CvUploader", document.getElementById("rjupload"));
                        const validateInputs: ValidatedForm[] = getAllInstancesByName("ValidatedForm");
                        for(const instance of validateInputs) {
                            if(instance.specials.indexOf(uploader) > -1) {
                                this.checkWithUploader = instance;
                            }
                        }
                     }
                     PubSub.subscribe("upload-cv-done",()=>{
                         //reload option select in list cv after new cv is uploaded
                         setTimeout(() => {
                             this.reloadOptions(undefined);
                             this.selectOption(this.options[this.options.length - 1], true)
                         }, 300);
                         
                    })

                  }
            }
        }

         setTimeout(() => {
           window.dispatchEvent(new Event("resize"));
         }, 100);
    }
    /**
     * This function generate some DOM elements and give them some handlers to work with the drop down menu
     */
    generate():HTMLElement {
        const wrapper = document.createElement("div");
        this.button = document.createElement("label");
        this.button.setAttribute("for", this.name + this.randomnumber + "_button");
        
            this.button.addEventListener("click",()=> {
                setTimeout(() => {
                    window.dispatchEvent(new Event("resize"));
                },10)
                PubSub.publish("selector.focus", this);

                if(window.innerWidth < 767 &&  document.querySelectorAll('[data-facets].side')[0]) {
                    setTimeout(()=>{
                        const container = document.querySelectorAll('[data-facets].side')[0];
                        const buttonOffset = getOffset(this.button);
                        const scrollcontainer =  container.scrollTop;
                        const $top = (buttonOffset.top + scrollcontainer)  - 50;

                        container.scrollTo({
                            top: $top,
                            behavior: 'smooth'
                        });
                    },100)
                }
            })
        
        wrapper.appendChild(this.button);
        
        //ugly shit used in enterprise page...
        if (this.name == "l" || this.isLocalityIAndClassicSerp()) {
            const spanButton = document.createElement("div");
            let spanButtonText: Text;
            if (this.default != "") {
                spanButtonText = document.createTextNode(this.default);
            } else {
                spanButtonText = document.createTextNode(this.placeholder);
            }
            spanButton.appendChild(spanButtonText);
            this.button.appendChild(spanButton);
        }  
        this.choiceWrapper = document.createElement("div");
        this.choiceWrapperList = document.createElement("div");
        this.choiceWrapper.appendChild(this.choiceWrapperList);
         for (let i = 0; i < this.column; i++) {
            this.choices.push(document.createElement("ul"));
            if (this.unselector) {
                this.choices[i].classList.add("unselector");
            }
            this.choiceWrapperList.appendChild(this.choices[i]);
        }
        if (this.unselector) {
            this.unselectAllLbl = document.createElement("label");
            this.unselectAllLbl.innerText = "Tout désélectionner";
            this.choiceWrapperList.appendChild(this.unselectAllLbl);
            this.unselectAllLbl.addEventListener("click", ()=>{this.unselectAll(false, true)});
        }
        wrapper.appendChild(this.choiceWrapper);
        if (this.labelAfter && this.placeholder) {
            const labAfterElt = document.createElement("label");
            labAfterElt.setAttribute("for", this.name + this.randomnumber + "_button");
            labAfterElt.innerText = this.placeholder;
            wrapper.appendChild(labAfterElt);
        }
         // when a click is triggered outside the dropdown, this one should collapse
        if (this.forceBlur == "forceBlur") {
            window.addEventListener("click", (event)=> {this.blurIt(event)});
        }
        this.reloadOptions(true);
        this.checkMore();

        return wrapper;
    }
    toggleBind(groups:any[]):void {
        this.initState = [];
        for (let i = 0; i < groups.length; i++) {
            this.checkSelected(groups[i]);
        }
        
        this.checkMore();
    }
    reloadOptions(nofirechange?:boolean, nounselect?:boolean):void {
        if(!nounselect) {
            this.unselectAll(nofirechange)
        }
        this.clearOptions()
        this.clearGroups()
        this.usedChoice = 0;
        this.initState = [];
        this.addOptions(this.element.children)
        const binders = this.searchBinder();
        for (let i = 0; i < binders.length; i++) {
            this.registerBinder(binders[i]);
        }
        if (this.name !== "l" && !this.isLocalityIAndClassicSerp()) {
            this.registerBinder(this.button, true);
        }
        this.toggleBind(this.groups);
    }

    addTag(option: any) {
        // Create list element
        const li = document.createElement("li");
        li.setAttribute("data-id", option.getAttribute("value"));
        li.innerHTML = option.innerHTML;
        const svghelper = "http://www.w3.org/2000/svg";
        const svg: unknown = document.createElementNS(svghelper, "svg");
        (<HTMLElement>svg).setAttribute("data-load-url", hw.getBaseRessourcesUrl() + "/img/svg/close0.svg")
        // Add the list element
        li.appendChild((<HTMLElement>svg));
        this.belowUl.appendChild(li);

        initialiseComponents();

        // Add handler on close icon
        li.querySelector("svg").addEventListener("click", ()=> {
            this.selectOption(option);
        });
    }

    selectOption(option:any, nofireuploader?:boolean, nofirechange?:boolean, value?:any):void {
        const index = this.options.indexOf(option);
         if (index > -1) {
            const selector = this.selectors[index];
            if (!this.multiple) {
                for (let i = 0; i < this.groups.length; i++) {
                    this.unselect(this.groups[i], true);
                }
            }
            let selectIt = !this.multiple || !option.selected;
            if (typeof value != "undefined") {
                selectIt = value;
            }
            if (selectIt) {
                selector.classList.add("selected");
                if( selector.parentNode) {
                    selector.parentNode.classList.add("s");
                }
                option.selected = true;
                if (option.nodeName == "OPTGROUP" && this.multiple && option.children.length == 1) {
                    option.children[0].selected = true;
                }
                if (this.multiple && option.nodeName == "OPTION") {
                    const pa = option.parentNode;
                    if (pa.nodeName == "OPTGROUP") {
                        let sel = 0;
                        for (let i = 0; i < pa.children.length && sel==i; i++) {
                            if (pa.children[i].selected) {
                                sel++;
                            }
                        }
                        if (sel == pa.children.length) {
                            if (!pa.selected) {
                                this.selectOption(pa, true, true, true);
                            }
                        }
                        this.launch = true;
                    }
                }
                if(this.name === "ray" || this.workAsRay) {
                    const $spanRay =  this.button.querySelectorAll('span')[1];
                    $spanRay.innerText = option.label;
                    $spanRay.classList.add('selected');
                    if (option.value) {
                        $spanRay.setAttribute("data-value", option.value);
                    } else {
                        $spanRay.removeAttribute("data-value");
                    }
                }
                if (this.displayBelow) {
                    this.addTag(option);
                }
            } else {
                selector.classList.remove("selected");
                option.selected = false;
                if (option.nodeName == "OPTGROUP" && this.multiple && option.children.length == 1) {
                    option.children[0].selected = false;
                }
                if (this.multiple && option.nodeName == "OPTION") {
                    const pa = option.parentNode;
                    if (pa.nodeName == "OPTGROUP") {
                        this.launch = true;
                        if (pa.selected) {
                            this.selectOption(pa, true, true, false);
                        }           
                    }
                }

                if (this.displayBelow) {
                    const li = this.belowUl.querySelector('li[data-id="' + option.getAttribute("value") + '"]');
                    if (li) {
                        this.belowUl.removeChild(li);
                    }
                }
            }
            
            this.checkMore()
            if(!nofirechange || this.launch === true) {
                    if(this.launch == true) {
                        if(this.timeout) {
                            clearTimeout(this.timeout)
                        }
                        this.timeout = setTimeout(()=>{
                            PubSub.publish("selector-option.selected",this)
                            this.launch = false; 
                        },300)
                    } else {
                       PubSub.publish("selector-option.selected",this)
                    }                        
            }
            if (!this.multiple) {
                if (this.default !== "") {
                    this.openInput.checked = false;
                  //  self.fireBlur();
                } else {
                    if(this.name == "ray" || this.workAsRay) {
                        this.openInput.checked = false;
                     //   self.fireBlur();
                    }
                }
            }
            if (this.checkWithUploader && !nofireuploader) {
                this.checkWithUploader.check();
            } 

         }
    }
    updateOptions(updatedOptions:any):void {
        if (this.facet || this.fakeFacet) {
            for (let j = 0; j < this.options.length ; j++) {
                let found = false;
                for (let i = 0; i < updatedOptions.length && !found; i++) {
                    if (updatedOptions[i].Id && updatedOptions[i].Id == this.options[j].value) {
                        found = true;
                        const counts = this.selectors[j].querySelectorAll("span");
                        if (counts.length > 0 && updatedOptions[i].Count > 0) {
                          counts[0].innerText = updatedOptions[i].Count;
                        }
                        
                    }
                }
                if (!found) {
                    const counts = this.selectors[j].querySelectorAll("span");
                    if (counts.length > 0) {
                        counts[0].innerText = "";
                    }
                }
            }
        }
    }
    unselect(group:any, nofireevent?:boolean):void {
        group.selector.classList.remove("selected");
        group.option.selected = false;

        if( group.selector.parentNode) {
            group.selector.parentNode.classList.remove("s");
        }

        if (this.displayBelow) {
            const li = this.belowUl.querySelector('li[data-id="' + group.option.getAttribute("value") + '"]');
            if (li) {
                this.belowUl.removeChild(li);
            }
        }

        if (group.option.nodeName == "OPTGROUP" && this.multiple && group.option.children.length == 1) {
            group.option.children[0].selected = false;
        }
        
        this.checkMore();
        if (!nofireevent) {
             PubSub.publish("selector-option.unselected",this)
        }
    }
    unselectAll(nofirechange?:boolean,unselector?:boolean):void {
        if (unselector && this.unselectAllLbl.innerText == "Tout sélectionner") {
            for (let i = 0; i < this.groups.length; i++) {
                this.selectOption(this.groups[i].option, true, true, true);
            }
        } else {
            for (let i = 0; i < this.groups.length; i++) {
                this.unselect(this.groups[i], true);
            }
        }
        if (!nofirechange) {
              PubSub.publish("selector-option.unselected",this) 
        }
    }
    blurIt(event:Event):void {
        if (event.target === this.openInput) {return;}
        this.eventHistory = [];
        if (this.openInput.checked) {
            if (event.target == this.button) {
                this.eventHistory.push(event);
            } else {
                const eventCustom = event as EventCustom;
                let blurRect = {top : 0, left : 0, bottom : 0, right : 0};
                let buttonOffset = getOffset(this.button);
                blurRect.top = buttonOffset.top;
                blurRect.left = buttonOffset.left;
                blurRect.right = blurRect.left + this.button.offsetWidth;
                blurRect.bottom = blurRect.top + this.button.offsetHeight;
                

                if (!(eventCustom.x > blurRect.left && eventCustom.x < blurRect.right && eventCustom.y > blurRect.top && eventCustom.y < blurRect.bottom)) {
                    blurRect = {top : 0, left : 0, bottom : 0, right : 0};
                    buttonOffset = getOffset(this.choiceWrapper);
                    blurRect.top = buttonOffset.top;
                    blurRect.left = buttonOffset.left;
                    blurRect.right = blurRect.left + this.choiceWrapper.offsetWidth;
                    blurRect.bottom = blurRect.top + this.choiceWrapper.offsetHeight;

                    if (!(eventCustom.x > blurRect.left && eventCustom.x < blurRect.right && eventCustom.y > blurRect.top && eventCustom.y < blurRect.bottom)) {
                            if (this.eventHistory.indexOf(event) < 0) {
                                this.openInput.checked = false;
                            }
                        
                    }
                }
            }
             setTimeout(() => {
               window.dispatchEvent(new Event("resize"));
             }, 10);
        }
    }
    searchBinder():any[] {
        const allBinders = document.querySelectorAll("[data-binder]");
        const result:any = [];
        for (let i = 0; i < allBinders.length; i++) {
            let data:any = allBinders[i].getAttribute("data-binder");
            if (data) {
                data = JSON.parse(allBinders[i].getAttribute("data-binder"));
                if (data.name) {
                    const tokens = data.name.split(",");
                    for (let j = 0; j < tokens.length; j++) {
                        if (tokens[j].trim() == this.name) {
                            result.push(allBinders[i]);
                        }
                    }
                }
            }
            
        }
        return result;
    }
    registerBinder(element:any,hasPlaceHolder?:boolean):void {
        const moreTag = document.createElement("span");
        const moreSpan = document.createElement("span");
        if (this.pluriel !== "") {
            moreSpan.appendChild(document.createTextNode(this.pluriel));
        } else {
            if (this.default != "") {
                moreSpan.appendChild(document.createTextNode(this.default));
            } else {
                moreSpan.appendChild(document.createTextNode(this.placeholder));
            }
        }
        
        moreTag.appendChild(moreSpan);
        if (!hasPlaceHolder) {
            moreTag.addEventListener("click", (e)=>{this.unselectAll()});
        }
        let placeHolder:any;
        if (hasPlaceHolder) {
             placeHolder = document.createElement("div");
            if (this.default != "") {
                placeHolder.appendChild(document.createTextNode(this.default));
            } else {
                placeHolder.appendChild(document.createTextNode(this.placeholder));
            }
        }
        this.groupOptions(element, moreTag, placeHolder);
    }
    checkMore():void {
        let selecteds = 0;
        for (let i = 0; i < this.options.length; i++) {
            if (this.options[i].selected) {
                selecteds++;
            }
            
        }
        if (this.unselector) {
            if (selecteds > 1) {
                this.unselectAllLbl.innerText = "Tout désélectionner";
            } else {
                this.unselectAllLbl.innerText = "Tout sélectionner";
            }
        }
        // patch degueu sur les localites
        if(this.name !== "ray" && this.name !== "l" && !this.isLocalityIAndClassicSerp() && this.name !== "msa" && !this.workAsRay) {
            for (let i = 0; i < this.groups.length; i++) {
                const group = this.groups[i];
                for (let j = 0; j < group.binder.tags.length; j++) {
                    if (group.binder.element.contains(group.binder.tags[j])) {
                        group.binder.element.removeChild(group.binder.tags[j]);
                    }
                }
                if (selecteds > group.binder.limit) {
                    if (!group.binder.element.contains(group.binder.moreTag)) {
                        group.binder.element.appendChild(group.binder.moreTag);
                    }
                    while(group.binder.moreTag.firstChild) group.binder.moreTag.removeChild(group.binder.moreTag.firstChild);
                    if (this.pluriel != "") {
                        group.binder.moreTag.innerText = selecteds + " " + this.pluriel;
                    } else {
                        if (this.default != "") {
                            group.binder.moreTag.innerText = this.default;
                        } else {
                            group.binder.moreTag.innerText = this.placeholder;
                            const past = document.createElement("span");
                            past.classList.add("past");
                            past.innerText = "" + selecteds;
                            group.binder.moreTag.appendChild(past);
                        }
                        
                    }
                    
                } else {
                    if (group.binder.element.contains(group.binder.moreTag)) {
                        group.binder.element.removeChild(group.binder.moreTag);
                    }
                    for (let k = 0; k < this.options.length; k++) {
                        if (this.options[k].selected) {
                            group.binder.element.appendChild(group.binder.tags[k]);
                        }
                    }
                }
                if (group.binder.placeHolder) {
                    if (selecteds < 1) {
                        group.binder.element.appendChild(group.binder.placeHolder);
                    } else {
                        if (group.binder.element.contains(group.binder.placeHolder)) {
                            group.binder.element.removeChild(group.binder.placeHolder);
                        }
                    }
                }
            }
        }
    }
    addOptions(options:any, choices?:any): any[] {
        const result = [];
        const forceChoice = choices ? true : false;
        choices = choices ?? this.choices;
        for (let i = 0; i < options.length; i++) {
            const option = options[i];
            if (option.nodeName == "OPTION") {
                this.options.push(option);
                const li = document.createElement("li");
                let label:any;
                if (this.type && this.type == "flag") {
                    const flagValue = option.getAttribute("value");
                    label = document.createElement('div');
                    const htmlString = '<span class="flag-' + flagValue + '" data-flag="' + flagValue + '"><span>(+' + flagValue + ') </span>' + option.innerText + '</span>';
                    label.innerHTML = htmlString.trim();
                    // Change this to div.childNodes to support multiple top-level nodes
                    label = label.firstChild; 
                } else {
                    if (option.hasAttribute("data-pagination-type")) {
                        li.classList.add(option.getAttribute("data-pagination-type"));
                        if(option.getAttribute("data-pagination-type") === "next" || option.getAttribute("data-pagination-type") === "previous" ) {
                            const svghelper = "http://www.w3.org/2000/svg";
                            const nextSvg = document.createElementNS(svghelper, "svg");
                            nextSvg.setAttribute("data-load-url", hw.getBaseRessourcesUrl() + "/img/svg/next.svg")
                            li.appendChild(nextSvg);
                            initialiseComponents();
                        }
                    }
                    if (option.value) {
                        li.setAttribute("data-value", option.value);
                    }
                    label = document.createElement("label");
                   
                    let $optionValue = option.innerText;
                    if(option.hasAttribute("data-count")) {
                        const labelregex = new RegExp("/", "g");
                        $optionValue = $optionValue.replace(labelregex, " • ");
                    }
                   
                    if (this.src) {           
                            if (this.src[0] == "accountData") {
                                if($optionValue.length > 35) {
                                   $optionValue = $optionValue.trim();
                                   $optionValue = $optionValue.substring(0,35) + "..";
                                }
                            }                            
                    }

                    const labelText = document.createTextNode($optionValue);
                    label.appendChild(labelText);
                    if (this.facet || this.fakeFacet) {
                        const count = document.createElement("span");
                        if (option.hasAttribute("data-count")) {
                            this.listenCount(option, count);
                            count.classList.add("facetnb");
                        }
                        label.appendChild(count);
                    }
                }
                li.appendChild(label);
                let choicesToSet:any;
                if (!forceChoice) {
                    const length = this.calculateLength(choices[this.usedChoice]);
                    if (length >= (this.numberOnColumn + (this.usedChoice < (this.moduloOnColumn - 1) ? 1 : 0)) && this.usedChoice < this.column - 1) {
                        this.usedChoice++;
                    }
                    choicesToSet = choices[this.usedChoice];
                } else {
                    choicesToSet = choices[0];
                }
                choicesToSet.appendChild(li);
                this.selectors.push(label);
                if (li.dataset.value) {
                    li.addEventListener("click", (e)=> {
                        e.stopPropagation();
                        this.select(e)
                    });
                } else {
                    li.classList.add('default-cursor')
                }
                result.push(label);
            } else {
                 if (option.nodeName == "OPTGROUP") {
                    const li = document.createElement("li");
                    li.classList.add("title");
                    const label = document.createElement("label");
                    const labelregex = new RegExp("/", "g");
                    let $optionValue = option.label
                    $optionValue = $optionValue.replace(labelregex, " • ");
                    label.appendChild(document.createTextNode($optionValue));
                    if (this.facet || this.fakeFacet) {
                        const count = document.createElement("span"); 
                        if (option.hasAttribute("data-count")) {
                            this.listenCount(option, count);
                            count.classList.add("facetnb");    
                        }
                        label.appendChild(count); 
                    }
                    li.appendChild(label);
                    let choicesToSet;
                    if (!forceChoice) {
                        const length = this.calculateLength(choices[this.usedChoice]);
                        if (length >= (this.numberOnColumn + (this.usedChoice < (this.moduloOnColumn - 1) ? 1 : 0)) && this.usedChoice < this.column - 1) {
                            this.usedChoice++;
                        }
                        choicesToSet = choices[this.usedChoice];
                    } else {
                        choicesToSet = choices[0];
                    }
                    choicesToSet.appendChild(li);
                    if (this.multiple) {
                        this.options.push(option);
                        this.selectors.push(label);
                    }
                    if (this.multiple && option.children.length == 1 && !this.displaySingle) {
                        option.setAttribute("value", option.children[0].value);
                        li.addEventListener("click", (e)=> {
                            e.stopPropagation();
                            this.select(e)
                        });
                    } else {
                        const nested = document.createElement("ul");
                        const litchi = this.addOptions(option.children, [nested]);
                        li.appendChild(nested);
                        if (this.multiple) {
                            this.handleSuperSelect(label, litchi);
                        }
                    }
                    result.push(label);
                }
            }
        }
        return result;
    }
    listenCount(option:any,count:HTMLElement):void {
        const retrieveCount = (skipOptgroup = false) => {
            const dataCountInstance: DataCount = getSingleInstanceByElement("DataCount",option)
            if(dataCountInstance) {
                const ct = dataCountInstance.data;
                if (ct && ct !== "" && parseInt(ct + "") > 0) {
                    count.innerText = "("+numberWithSpace(parseInt(ct+""))+")";
                } else {
                    count.innerText = "";
                }
            }
            if (skipOptgroup && option.nodeName == "OPTGROUP") {
              count.innerText = "";
            }
        }
        retrieveCount()
        PubSub.subscribe("dataCount-loaded", () => {
          retrieveCount(true);
        });
    }
    calculateLength(ulist:any):number {
        if (ulist) {
            let result = 0;
            const children = ulist.children;
            for (let i = 0; i < children.length; i++) {
                if (children[i].nodeName == "LI") {
                    result++;
                    for (let j = 0; j < children[i].children.length; j++) {
                        if (children[i].children[j].nodeName == "UL") {
                            result+=2;
                            result += this.calculateLength(children[i].children[j]);
                        }
                    }
                    
                }
            }
            return result;
        }
        return -1;
    }

    select(e:Event, litch?:any) {
        if (litch) {
            if (Array.isArray(litch)) {
                const loptions = [];
                let sel = true;
                for (let i = 0; i < litch.length; i++) {
                    let lindex = this.selectors.indexOf(litch[i]);
                    while (lindex < 0 && litch[i].parentNode) {
                        litch[i] = litch[i].parentNode;
                        lindex = this.selectors.indexOf(litch[i]);
                    }
                    const loption = this.options[lindex];
                    loptions.push(loption);
                    sel = sel && loption.selected;
                }
                for (let j = 0; j < loptions.length; j++) {
                    this.selectOption(loptions[j], true, true, !sel);
                }
            } else {
                let selector = litch;
                let index = this.selectors.indexOf(selector);
                while (index < 0 && selector.parentNode) {
                    selector = selector.parentNode;
                    index = this.selectors.indexOf(selector);
                }
                const option = this.options[this.selectors.indexOf(selector)];
                this.selectOption(option);
            }
        } else {
            let selector = e.target as any;
            let index = this.selectors.indexOf(selector);
            while (index < 0 && selector.parentNode) {
                selector = selector.parentNode;
                index = this.selectors.indexOf(selector);
            }
            const option = this.options[this.selectors.indexOf(selector)];
            this.selectOption(option);
        }
    }
    handleSuperSelect(label: HTMLElement, elts:any[]) {
        label.addEventListener("click", (e)=> {
            e.stopPropagation();
            this.select(e, elts.length ? elts : label)
        });
    }
    clearOptions():void {
        for(let i = 0; i < this.choices.length; i++) {
            while(this.choices[i].firstChild) this.choices[i].removeChild(this.choices[i].firstChild);
        }
        this.options = [];
        if (this.name !== "l" && !this.isLocalityIAndClassicSerp()) {
            while(this.button.firstChild) this.button.removeChild(this.button.firstChild);
        }
    }
    clearGroups():void {
        for (let i = 0; i < this.groups.length; i++) {
            if (this.groups[i].placeHolder) {
                this.groups[i].placeHolder.remove();
            }
            if (this.groups[i].moreTag) {
                this.groups[i].moreTag.remove();
            }
            if (this.groups[i].tags) {
                for (let j = 0; j < this.groups[i].tags.length; j++) {
                    this.groups[i].tags[j].remove();
                }
            }
        }
        this.groups = [];
        this.selectors = [];
    }
    groupOptions(element:any,moreTag:any,placeHolder?:any):void {
        const tags = [];
         for (let i = 0; i < this.options.length; i++) {
            const option = this.options[i];
            const selector = this.selectors[i];
            let tag:HTMLElement;
            if (this.type == "flag") {
                tag = document.createElement("span");
                const span = document.createElement("span");
                span.appendChild(document.createTextNode("+(" + option.value + ")"));
                tag.classList.add("flag-" + option.value);
                tag.appendChild(span);
            } else {
                tag = document.createElement("span");
                const span = document.createElement("span");
                if (this.default != "") {
                    span.appendChild(document.createTextNode(option.innerText));
                } else {
                    span.appendChild(document.createTextNode(this.placeholder));
                    if (this.facet || this.fakeFacet) {
                        if ((this.multiple || i != 0) && this.pastActiv) {
                            const past = document.createElement("span");
                            past.classList.add("past");
                            past.innerText = "1";
                            span.appendChild(past);
                        }
                    }
                }
                
                tag.appendChild(span);
            }
            tags.push(tag);
            const group = {"selector" : selector, "option" : option, "tag" : tag, "binder" : {
                "element" : element,
                "limit" : 1,
                "moreTag" : moreTag, 
                "placeHolder" : placeHolder,
                "tags" : tags
            }};
            this.setLiEvent(group);
            this.groups.push(group);
            PubSub.publish("selector-group.ready")
        }
    }
    setLiEvent(group:any):void {
        if (this.multiple) {
            if (group.element !== this.button) {
                if(group.tag != null) {
                    group.tag.addEventListener("click", (event:Event)=>{
                                const target:any = event.target;
                                if(target.parentNode !== this.button) {
                                    event.stopPropagation();
                                }                              
                                const parent = target.parentNode.closest('[data-binder]')
                                if(parent) {
                                    this.unselect(group)
                                }                             
                            });
                        }             
                 }                                  
        }
    }
    selectByValues(options:any[]):void {
        for (let i = 0; i < options.length; i++) {
            const opt = options[i];
            let res = false;
            for (let j = 0; j < this.options.length && !res; j++) {
                const option = this.options[j];
                if ((opt.value && opt.value == option.value) || (opt == option.value)) {
                    res = true;
                    this.selectOption(option, true, true, true);
                }
            }
        }
    }
    checkSelected(group:any, init?:boolean):void {
        if (this.multiple && group.option.nodeName == "OPTGROUP") {
            let sel = 0;
            for (let i = 0; i < group.option.children.length && sel==i; i++) {
                if (group.option.children[i].selected) {
                    sel++;
                }
            }
            if (sel == group.option.children.length) {
                if (sel == 0 && this.supername) {
                    group.option.selected = false;
                } else {
                    group.option.selected = true;
                }
            }
        }
        const li = this.belowUl?.querySelector('li[data-id="' + group.option.getAttribute("value") + '"]');
        if (group.option.selected) {
            
            if (!group.binder.element.contains(group.tag)) {
                group.binder.element.appendChild(group.tag);
            }
            try {
                group.selector.classList.add("selected");
                if( group.selector.parentNode) {
                    group.selector.parentNode.classList.add("s");
                }
                 
                if(this.name === "ray" || this.workAsRay) {
                    const $spanRay =  this.button.querySelectorAll('span')[1];
                    if($spanRay) {
                        $spanRay.innerText = group.option.text;
                        $spanRay.classList.add('selected');
                    } 
                }
            }
            catch(e) { e }
            if(this.displayBelow && window.innerWidth < 768) {
                // create a tag with option value if that tag doesn't already exist when we select an option
                if (!li) {
                    this.addTag(group.option);
                }
            }
           
        } else {
            if (group.binder.element.contains(group.tag)) {
                group.binder.element.removeChild(group.tag);
            }
            try {
                group.selector.classList.remove("selected");
            }
            catch(e) { e }
             if(this.displayBelow && window.innerWidth < 768) {
                // remove the tag linked to the option when we unselect an option
                if (li) {
                  this.belowUl.removeChild(li);
                }
             }
        }
    }
    getSelectedOptions():any[] {
        const options = [];
        for (let i = 0; i < this.groups.length; i++) {
            if (this.groups[i].option.selected) {
                options.push(this.groups[i].option)
                if (this.groups[i].option.nodeName == "OPTGROUP" && this.multiple && this.groups[i].option.children.length == 1) {
                    options.push(this.groups[i].option.children[0]);
                }
            }
        }
        return options;
    }
    getValue():any[] {
        const opt = this.getSelectedOptions();
        const res = [];
        for (let i = 0; i < opt.length; i++) {
            res.push(opt[i].value);
        }
        return res;
    }
    getCriterionFormatValue():SimpleSelectItem[] {
        const opt = this.getSelectedOptions();
        const res:SimpleSelectItem[] = [];
        for (let i = 0; i < opt.length; i++) {
            res.push({
                "label": opt[i].innerText,
                "uri": opt[i].value,
                isValid() {
                    return !!this.uri;
                }
            });
        }
        return res;
    }
    indexOf(option:string):number {
        for (let i = 0; i < this.groups.length; i++) {
            if (this.groups[i].option == option) {
                return i;
            }
        }
        return -1;
    }
    unselectOption(option:any, fireChange?:boolean):void {
        const noFireChange = !fireChange ? true : false;
        for (let i = 0; i < this.groups.length; i++) {
            if (this.groups[i].option == option) {
                this.unselect(this.groups[i], noFireChange);
            }
        }
    }
    enableTracking(data:any, tracker:any):void {
        const cat = data.EventCat ? data.EventCat : "Choix Multiple";
        const lib = getSubTypePage() + " - " + (data.EventLibelle ? data.EventLibelle : this.facet ? this.facet : this.name);

        const openEvent = {
            EventCat : cat,
            EventAction : data.EventAction ? data.EventAction : "Load",
            EventLibelle : lib,
            trigger : "focus"
        }
        const closeEvent = {
            EventCat : cat,
            EventAction : data.EventAction ? data.EventAction : "Unload",
            EventLibelle : lib,
            trigger : "blur"
        };
        tracker.addEvents([openEvent, closeEvent], this);
    }

    // Locality facet ("com" name) have a different behavior in classic SERP as it's not displayed 
    // in the facets panel. In company SERP, we can handle it the same way as the other facets.
    isLocalityIAndClassicSerp(): boolean {
        return (this.name === "com" && this.form !== "company");
    }
}